/**
 * Status bar — footer cursor coordinate and zoom level display.
 */

/**
 * Update the cursor coordinate readout in the footer.
 *
 * @param {number | null} lat - Pass null to show placeholder dashes
 * @param {number | null} lng
 */
export function updateCursor(lat, lng) {
  const el = document.getElementById("cursor-coords");
  if (!el) return;

  if (lat === null || lng === null || isNaN(lat) || isNaN(lng)) {
    el.textContent = "lat: —, lng: —";
  } else {
    el.textContent = `lat: ${lat.toFixed(6)}, lng: ${lng.toFixed(6)}`;
  }
}

/**
 * Update the color indicator in the footer status bar.
 *
 * @param {string} name - Human-readable color name e.g. "Sage"
 * @param {string} hex  - Hex color string e.g. "#a8c5a0"
 */
export function updateColor(name, hex) {
  const swatchEl = document.getElementById("color-swatch-indicator");
  const nameEl   = document.getElementById("color-name-indicator");
  if (swatchEl) swatchEl.style.background = hex;
  if (nameEl)   nameEl.textContent = name;
}

/**
 * Update the zoom level readout in the footer.
 *
 * @param {number} scale - e.g. 1.5 for 150%
 */
export function updateZoom(scale) {
  const el = document.getElementById("zoom-level");
  if (!el) return;

  el.textContent = `${Math.round(scale * 100)}%`;
}

/**
 * Update the edge length readout in the footer.
 *
 * @param {number | null} meters - Pass null to clear the display (not hovering an edge)
 */
export function updateEdgeLength(meters) {
  const el = document.getElementById("edge-length");
  if (!el) return;

  if (meters === null) {
    el.textContent = "";
  } else if (meters < 1000) {
    el.textContent = `Edge: ${meters.toFixed(1)} m`;
  } else {
    el.textContent = `Edge: ${(meters / 1000).toFixed(2)} km`;
  }
}

/**
 * Show a temporary message in the status bar footer.
 * The message is auto-cleared after the given duration.
 *
 * @param {string} message - Message text to display
 * @param {number} [duration=3000] - Duration in milliseconds before clearing
 */
export function showTemporaryMessage(message, duration = 3000) {
  const el = document.getElementById("status-message");
  if (!el) return;

  el.textContent = message;

  // Clear any existing timeout to prevent early clearing if called again
  if (el._timeout) {
    clearTimeout(el._timeout);
  }

  el._timeout = setTimeout(() => {
    el.textContent = "";
    el._timeout = null;
  }, duration);
}
